import ContentLoader from "react-content-loader"
import tw from "tailwind-styled-components"

const Container = tw.div`
  relative
  flex
  flex-col
  items-center
  justify-center
`

const TemplateSkeleton = () => {
  return (
    <Container>
      <ContentLoader
        speed={1.2}
        width={300}
        height={650}
        viewBox="0 0 300 650"
        className="!w-full !h-full max-h-[650px] min-w-[0px] max-w-[300px]"
        backgroundColor={"hsla(218, 14%, 18%, 0.5)"}
        foregroundColor={"hsla(218, 14%, 18%, 1)"}
      >
        {/* Template name */}
        <rect x="75" y="10" rx="3" ry="3" width="150" height="20" />

        {/* Sublabel (Created/Updated date) */}
        <rect x="95" y="40" rx="3" ry="3" width="110" height="10" />

        {/* Preview image container */}
        <rect x="10" y="70" rx="16" ry="16" width="280" height="560" />

        {/* Inner preview image */}
        <rect x="20" y="80" rx="12" ry="12" width="260" height="540" />
      </ContentLoader>
    </Container>
  )
}

export default TemplateSkeleton
